
// export interface IProducPosttDtoModel {
//     id: number,
//     partNumber: string,
//     basePartNumber: string,
//     commodity: ICommodityDtoModel,
//     countryOfOriginCode: string,
//     taxRateCategoryId: number
// }

import { ICommodityCodes } from "../../commodity-dto.model";


export interface IProducPosttDtoModel {
  id?: string;
  partNumber: string;
  productTypeCode: string;
  englishShortTitle: string;
  partStatusCode: string;
  componentStatusCode: string;
  commodity: ICommodityCodes;
  countryOfOriginCode: string;
  taxRateCategoryCode: number;
  discountCategoryCode: string;
  taxonomyCode: string;
}